import React from "react";
import { FiDownload } from "react-icons/fi";

function HeroSection() {
  return (
    // Menggunakan bg-transparent atau bg-gsf-sage agar menyatu dengan layout utama
    <div className="bg-transparent p-4 sm:p-8 font-sans selection:bg-gsf-sand flex items-center">
      {/* ─── MAIN HERO CARD ─── */}
      <main className="mx-auto max-w-7xl w-full border-2 border-slate-900 bg-white rounded-3xl p-8 lg:p-16 shadow-[10px_10px_0px_0px_#ccd5ae] relative overflow-hidden bg-grid-pattern transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[10px_10px_0px_0px_#d4a373]">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center relative z-10">
          {/* Sisi Kiri: Teks & CTA */}
          <div className="lg:col-span-7 space-y-6">
            {/* Badge */}
            <div className="flex flex-wrap gap-2 text-[10px] sm:text-xs font-bold uppercase tracking-widest text-gsf-bronze bg-gsf-sand/40 border border-gsf-bronze/20 px-3 py-1.5 rounded-lg w-fit">
              Software Engineer • Backend Engineer • System Designer
            </div>

            {/* Headline (Diubah menjadi gsf-bronze agar kontras tinggi dan estetik) */}
            <h1 className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-black text-slate-900 tracking-tight leading-none">
              Gugun
              <span className="text-gsf-bronze"> Jofandi</span>
            </h1>

            {/* Description */}
            <p className="text-base sm:text-lg text-slate-600 max-w-xl leading-relaxed font-medium">
              I build production software that transforms complex business
              requirements into scalable digital platforms through backend
              engineering, system architecture, and intelligent application
              development.
            </p>

            {/* CTA Buttons */}
            <div className="pt-2 flex flex-wrap items-center gap-4">
              {/* Tombol View Projects */}
              <a
                href="#projects"
                className="border-2 border-slate-900 bg-slate-900 px-6 py-3 font-bold text-sm text-white rounded-xl shadow-[3px_3px_0px_0px_#faedcd] transition-all duration-200 hover:-translate-y-0.5 hover:shadow-[5px_5px_0px_0px_#d4a373] active:translate-y-0"
              >
                View Projects
              </a>

              {/* Tombol Download Resume (Perbaikan Link Aktif & Kontras Visual) */}
              <a
                href="https://drive.google.com/file/d/1i3pRXHglT8azSPfsAFw5LHGXRmEqowqo/preview"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 rounded-xl border-2 border-slate-900 bg-white px-6 py-3 font-bold text-sm text-slate-700 shadow-[3px_3px_0px_0px_#faedcd] transition-all duration-200 hover:-translate-y-0.5 hover:shadow-[5px_5px_0px_0px_#ccd5ae] active:translate-y-0 hover:bg-gsf-cream"
              >
                <FiDownload className="text-base text-slate-600" />
                Download Resume
              </a>
            </div>
          </div>

          {/* Sisi Kanan: Mini Core Roles ala 2x2 Bento Grid (Ramping & Hemat Space Vertikal) */}
          <div className="lg:col-span-5 w-full flex items-center justify-center lg:justify-end">
            {/* Grid 2 Kolom untuk menghemat ruang ke bawah */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 w-full max-w-[460px]">
              {/* ─── 1. BACKEND ─── */}
              <div className="border-2 border-slate-900 bg-white rounded-xl overflow-hidden shadow-[4px_4px_0px_0px_#ccd5ae] hover:shadow-[5px_5px_0px_0px_#d4a373] hover:-translate-y-0.5 transition-all duration-300 flex flex-col group">
                <div className="border-b border-slate-900 bg-gsf-sand/30 px-3 py-1.5 flex items-center justify-between">
                  <p className="text-[11px] font-black uppercase tracking-wider text-slate-900">
                    Backend Eng.
                  </p>
                  <div className="flex gap-0.5 select-none">
                    <span className="w-1 h-1 rounded-full bg-slate-300 border border-slate-400"></span>
                    <span className="w-1 h-1 rounded-full bg-slate-300 border border-slate-400"></span>
                  </div>
                </div>
                <div className="p-3 bg-white relative">
                  <div className="flex flex-wrap gap-1 relative z-10">
                    {[
                      "Python",
                      "Golang",
                      "Flask",
                      "FastAPI",
                      "PostgreSQL",
                      "REST APIs",
                    ].map((tech) => (
                      <div
                        key={tech}
                        className="border border-slate-200 bg-white px-1.5 py-0.5 rounded-md font-mono text-[9px] font-bold text-slate-600 flex items-center gap-0.5 shadow-[1px_1px_0px_0px_#ccd5ae] group-hover:shadow-[1px_1px_0px_0px_#d4a373] transition-all"
                      >
                        <span className="text-gsf-bronze font-black select-none">
                          &gt;
                        </span>
                        {tech}
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* ─── 2. FULLSTACK ─── */}
              <div className="border-2 border-slate-900 bg-white rounded-xl overflow-hidden shadow-[4px_4px_0px_0px_#ccd5ae] hover:shadow-[5px_5px_0px_0px_#d4a373] hover:-translate-y-0.5 transition-all duration-300 flex flex-col group">
                <div className="border-b border-slate-900 bg-gsf-sand/30 px-3 py-1.5 flex items-center justify-between">
                  <p className="text-[11px] font-black uppercase tracking-wider text-slate-900">
                    Fullstack Eng.
                  </p>
                  <div className="flex gap-0.5 select-none">
                    <span className="w-1 h-1 rounded-full bg-slate-300 border border-slate-400"></span>
                    <span className="w-1 h-1 rounded-full bg-slate-300 border border-slate-400"></span>
                  </div>
                </div>
                <div className="p-3 bg-white relative">
                  <div className="flex flex-wrap gap-1 relative z-10">
                    {[
                      "React",
                      "Next.js",
                      "TypeScript",
                      "JavaScript",
                      "Tailwind CSS",
                      "Material UI",
                    ].map((tech) => (
                      <div
                        key={tech}
                        className="border border-slate-200 bg-white px-1.5 py-0.5 rounded-md font-mono text-[9px] font-bold text-slate-600 flex items-center gap-0.5 shadow-[1px_1px_0px_0px_#ccd5ae] group-hover:shadow-[1px_1px_0px_0px_#d4a373] transition-all"
                      >
                        <span className="text-gsf-bronze font-black select-none">
                          &gt;
                        </span>
                        {tech}
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* ─── 3. AI / ML ─── */}
              <div className="border-2 border-slate-900 bg-white rounded-xl overflow-hidden shadow-[4px_4px_0px_0px_#ccd5ae] hover:shadow-[5px_5px_0px_0px_#d4a373] hover:-translate-y-0.5 transition-all duration-300 flex flex-col group">
                <div className="border-b border-slate-900 bg-gsf-sand/30 px-3 py-1.5 flex items-center justify-between">
                  <p className="text-[11px] font-black uppercase tracking-wider text-slate-900">
                    AI
                  </p>
                  <div className="flex gap-0.5 select-none">
                    <span className="w-1 h-1 rounded-full bg-slate-300 border border-slate-400"></span>
                    <span className="w-1 h-1 rounded-full bg-slate-300 border border-slate-400"></span>
                  </div>
                </div>
                <div className="p-3 bg-white relative">
                  <div className="flex flex-wrap gap-1 relative z-10">
                    {[
                      "Machine Learning",
                      "Computer Vision",
                      "PyTorch",
                      "YOLO",
                      "OpenCV",
                      "LLM",
                    ].map((tech) => (
                      <div
                        key={tech}
                        className="border border-slate-200 bg-white px-1.5 py-0.5 rounded-md font-mono text-[9px] font-bold text-slate-600 flex items-center gap-0.5 shadow-[1px_1px_0px_0px_#ccd5ae] group-hover:shadow-[1px_1px_0px_0px_#d4a373] transition-all"
                      >
                        <span className="text-gsf-bronze font-black select-none">
                          &gt;
                        </span>
                        {tech}
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* ─── 4. SYSTEM DESIGN ─── */}
              <div className="border-2 border-slate-900 bg-white rounded-xl overflow-hidden shadow-[4px_4px_0px_0px_#ccd5ae] hover:shadow-[5px_5px_0px_0px_#d4a373] hover:-translate-y-0.5 transition-all duration-300 flex flex-col group">
                <div className="border-b border-slate-900 bg-gsf-sand/30 px-3 py-1.5 flex items-center justify-between">
                  <p className="text-[11px] font-black uppercase tracking-wider text-slate-900">
                    System Design
                  </p>
                  <div className="flex gap-0.5 select-none">
                    <span className="w-1 h-1 rounded-full bg-slate-300 border border-slate-400"></span>
                    <span className="w-1 h-1 rounded-full bg-slate-300 border border-slate-400"></span>
                  </div>
                </div>
                <div className="p-3 bg-white relative">
                  <div className="flex flex-wrap gap-1 relative z-10">
                    {[
                      "Docker",
                      "Linux",
                      "Nginx",
                      "System Design",
                      "CI/CD",
                      "Deployment",
                    ].map((tech) => (
                      <div
                        key={tech}
                        className="border border-slate-200 bg-white px-1.5 py-0.5 rounded-md font-mono text-[9px] font-bold text-slate-600 flex items-center gap-0.5 shadow-[1px_1px_0px_0px_#ccd5ae] group-hover:shadow-[1px_1px_0px_0px_#d4a373] transition-all"
                      >
                        <span className="text-gsf-bronze font-black select-none">
                          &gt;
                        </span>
                        {tech}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default HeroSection;
